import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Toggle from 'react-toggle';
import { v4 as uuid } from "uuid";

import actions from "react/api/actions";
import ResequenceItem from "./ResequenceItem.jsx";

class ResequenceHistory extends React.PureComponent {
  componentDidMount() {
    const { requestResequenceHistory } = this.props.resequenceHistoryActions;
    const { routeId } = this.props;
    const url = `ProactiveRouteOpt/${routeId}`;
    requestResequenceHistory({ url, routeId });
  }

  toggleChange = () => {
    const { resequenceHistory, resequenceHistoryActions, routeId } = this.props;
    const { switchToggle } = resequenceHistoryActions;
    const routeOptimizations = resequenceHistory.get(routeId);
    const toggleState = routeOptimizations.get('toggle');
    switchToggle({ routeId, toggleState: !toggleState });
  }

  render() {
    const { resequenceHistory, routeId } = this.props;
    const routeOptimizations = resequenceHistory.get(routeId) || null;
    const optimizationsArray = routeOptimizations ? routeOptimizations.get('optimizations') : [];
    const toggleState = routeOptimizations ? routeOptimizations.get('toggle') : false;
    const allSpanClass = !toggleState ?  'boldText' : 'lightText';
    const changesOnlySpanClass = toggleState ? 'boldText' : 'lightText';
    const showLabel = Monet.I18n.getResourcesByKey('resequenceContainer.show');
    const allLabel = Monet.I18n.getResourcesByKey('resequenceContainer.all');
    const changesOnlyLabel = Monet.I18n.getResourcesByKey('resequenceContainer.changesOnly');

    return (
      <div className="mainModalContainer">
        <div className="resequenceContainer">
          {optimizationsArray.map(item => {
            const {
              confirmed,
              priorNextStop,
              resequencedNextStop,
              finishedTime,
              resequenceTrigger,
              priorTotalTime,
              priorTotalDistance,
              priorMissedTimeWindows,
              resequencedTotalTime,
              resequencedTotalDistance,
              resequencedMissedTimeWindows,
            } = item;

            let sameStop = true; 
            if(resequencedNextStop && priorNextStop) {
              sameStop = resequencedNextStop.id === priorNextStop.id;
            }
            const description = (resequencedNextStop && resequencedNextStop.location) ? resequencedNextStop.location.description : '';
            const hour = moment(finishedTime).format("hh:mm A");
            const comparedTime = resequencedTotalTime - priorTotalTime;
            const comparedTimeWindow = resequencedMissedTimeWindows - priorMissedTimeWindows;
            const comparedDistance = resequencedTotalDistance - priorTotalDistance;

            return (
              <ResequenceItem
                key={`history-item-${uuid()}`}
                toggleState={toggleState}
                hour={hour}
                sameStop={sameStop}
                confirmed={confirmed}
                resequenceTrigger={resequenceTrigger}
                description={description}
                comparedTime={comparedTime}
                comparedTimeWindow={comparedTimeWindow}
                comparedDistance={comparedDistance}
              />
            );
          })}
        </div>
        <div className="changesOnly">
          <span className="showLabel">{`${showLabel}:`}</span>
          <div className="changesContainer">
            <span className={allSpanClass}>{allLabel}</span>
            <div className="toggleContainer">
              <Toggle 
                icons={false} 
                checked={toggleState}
                onChange={this.toggleChange}/>
            </div>
            <span className={changesOnlySpanClass}>{changesOnlyLabel}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ resequenceHistory }) => ({ resequenceHistory }),
  function mapDispatchToProps(dispatch) {
    return {
      resequenceHistoryActions: bindActionCreators(
        actions.resequenceHistory.actionCreators,
        dispatch,
      )
    };
  },
)(ResequenceHistory);
